import { FwOriginalIcon } from '@fourthwall/icons';
import unescape from 'lodash-es/unescape';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../Icon';
import * as S from './Dashboard.styled';
export const DashboardLogo = ({ name, src, append, to, href, hoverable = false, color, hideFwIcon = false, maxWidth, }) => {
    const getComponent = () => {
        if (to) {
            return Link;
        }
        if (href) {
            return 'a';
        }
        return 'div';
    };
    return (React.createElement(S.Container, { as: getComponent(), to: to, href: href, "$hoverable": hoverable, "$color": color, "$align": src ? 'center' : 'flex-start', "data-testid": "DashboardLogo" },
        !hideFwIcon && React.createElement(Icon, { component: FwOriginalIcon, height: 18 }),
        !src && name && (React.createElement(S.NameContainer, { "$withoutLogo": hideFwIcon, "$maxWidth": maxWidth },
            React.createElement(S.Name, null, name && unescape(name)))),
        src && (React.createElement(S.ImageContainer, null,
            React.createElement(S.Image, { src: src, alt: name && unescape(name) }))),
        append && React.createElement(S.Append, null, append)));
};
//# sourceMappingURL=DashboardLogo.js.map